import React from 'react';

import { HStack, Text } from '@vimeo/bokeh';
import { translate } from '@vimeo/i18n-runtime';

import { CreativeCommonsType } from '../../types';

export function CreativeCommons({
  creativeCommonsDescriptor,
}: React.PropsWithChildren<CreativeCommonsType>): React.ReactElement {
  const creativeCommonsLicenseText = () => {
    switch (creativeCommonsDescriptor) {
      case 'by':
        return `${translate('License')}: ${translate('Attribution')}`;
      case 'by-sa':
        return `${translate('License')}: ${translate('Attribution Share Alike')}`;
      case 'by-nd':
        return `${translate('License')}: ${translate('Attribution No Derivatives')}`;
      case 'by-nc':
        return `${translate('License')}: ${translate('Attribution Non-Commercial')}`;
      case 'by-nc-sa':
        return `${translate('License')}: ${translate('Attribution Non-Commercial Share Alike')}`;
      case 'by-nc-nd':
        return `${translate('License')}: ${translate('Attribution Non-Commercial No Derivatives')}`;
      case 'cc0':
        return `${translate('License')}: ${translate('Public Domain Dedication')}`;
      default:
        return '';
    }
  };

  return (
    <HStack>
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill="currentColor"
          d="M8.4841 9.234C8.4601 9.072 8.4061 8.925 8.3221 8.793C8.2381 8.655 8.1331 8.535 8.0071 8.433C7.8811 8.331 7.7371 8.253 7.5751 8.199C7.4191 8.139 7.2541 8.109 7.0801 8.109C6.7621 8.109 6.4921 8.172 6.2701 8.298C6.0481 8.418 5.8681 8.583 5.7301 8.793C5.5921 8.997 5.4901 9.231 5.4241 9.495C5.3641 9.759 5.3341 10.032 5.3341 10.314C5.3341 10.584 5.3641 10.848 5.4241 11.106C5.4901 11.358 5.5921 11.586 5.7301 11.79C5.8681 11.994 6.0481 12.159 6.2701 12.285C6.4921 12.405 6.7621 12.465 7.0801 12.465C7.5121 12.465 7.8481 12.333 8.0881 12.069C8.3341 11.805 8.4841 11.457 8.5381 11.025H9.9061C9.8701 11.427 9.7771 11.79 9.6271 12.114C9.4771 12.438 9.2791 12.714 9.0331 12.942C8.7871 13.17 8.4991 13.344 8.1691 13.464C7.8391 13.584 7.4761 13.644 7.0801 13.644C6.5881 13.644 6.1441 13.56 5.7481 13.392C5.3581 13.218 5.0281 12.981 4.7581 12.681C4.4881 12.381 4.2811 12.03 4.1371 11.628C3.9931 11.22 3.9211 10.782 3.9211 10.314C3.9211 9.834 3.9931 9.39 4.1371 8.982C4.2811 8.568 4.4881 8.208 4.7581 7.902C5.0281 7.596 5.3581 7.356 5.7481 7.182C6.1441 7.008 6.5881 6.921 7.0801 6.921C7.4341 6.921 7.7671 6.972 8.0791 7.074C8.3971 7.176 8.6791 7.326 8.9251 7.524C9.1771 7.716 9.3841 7.956 9.5461 8.244C9.7081 8.532 9.8101 8.862 9.8521 9.234H8.4841ZM14.655 9.234C14.631 9.072 14.577 8.925 14.493 8.793C14.409 8.655 14.304 8.535 14.178 8.433C14.052 8.331 13.908 8.253 13.746 8.199C13.59 8.139 13.425 8.109 13.251 8.109C12.933 8.109 12.663 8.172 12.441 8.298C12.219 8.418 12.039 8.583 11.901 8.793C11.763 8.997 11.661 9.231 11.595 9.495C11.535 9.759 11.505 10.032 11.505 10.314C11.505 10.584 11.535 10.848 11.595 11.106C11.661 11.358 11.763 11.586 11.901 11.79C12.039 11.994 12.219 12.159 12.441 12.285C12.663 12.405 12.933 12.465 13.251 12.465C13.683 12.465 14.019 12.333 14.259 12.069C14.505 11.805 14.655 11.457 14.709 11.025H16.077C16.041 11.427 15.948 11.79 15.798 12.114C15.648 12.438 15.45 12.714 15.204 12.942C14.958 13.17 14.67 13.344 14.34 13.464C14.01 13.584 13.647 13.644 13.251 13.644C12.759 13.644 12.315 13.56 11.919 13.392C11.529 13.218 11.199 12.981 10.929 12.681C10.659 12.381 10.452 12.03 10.308 11.628C10.164 11.22 10.092 10.782 10.092 10.314C10.092 9.834 10.164 9.39 10.308 8.982C10.452 8.568 10.659 8.208 10.929 7.902C11.199 7.596 11.529 7.356 11.919 7.182C12.315 7.008 12.759 6.921 13.251 6.921C13.605 6.921 13.938 6.972 14.25 7.074C14.568 7.176 14.85 7.326 15.096 7.524C15.348 7.716 15.555 7.956 15.717 8.244C15.879 8.532 15.981 8.862 16.023 9.234H14.655Z"
        />
        <rect stroke="currentColor" x="0.5" y="0.5" width="19" height="19" rx="9.5" />
      </svg>
      <a
        href="https://help.vimeo.com/hc/en-us/articles/12427652203153-What-do-the-different-Creative-Commons-licenses-mean"
        rel="noreferrer"
        target="_blank"
      >
        <Text variant="body-md">{creativeCommonsLicenseText()}</Text>
      </a>
    </HStack>
  );
}
